
const API_CONFIG = {

  DEFAULT_BASE_URL: 'https://hasanhaji.com',


  BASE_URL_STORAGE_KEY: 'api_base_url',
};


export const getApiBaseUrl = () => {
  return localStorage.getItem(API_CONFIG.BASE_URL_STORAGE_KEY) || API_CONFIG.DEFAULT_BASE_URL;
};


export const setApiBaseUrl = (url) => {
  if (url && url.trim() !== '') {
    localStorage.setItem(API_CONFIG.BASE_URL_STORAGE_KEY, url.trim());
    return true;
  }
  return false;
};


export const resetApiBaseUrl = () => {
  localStorage.removeItem(API_CONFIG.BASE_URL_STORAGE_KEY);
};

export default API_CONFIG;
